// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import { usePageRestrictionsContext } from '@confluence/page-restrictions-context/entry-points/PageRestrictionsContext.ts';
type PageViewRestrictionsProps = {
	children: (result: {
		error?: ApolloErrorInterop;
		hasDirectViewRestrictions: boolean;
		hasInheritedViewRestrictions: boolean;
	}) => JSX.Element | null;
};

export function PageViewRestrictions({ children }: PageViewRestrictionsProps): JSX.Element | null {
	const { restrictions, error, loading } = usePageRestrictionsContext();

	const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
	const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
	if (loading) {
		return null;
	}
	return children({
		error,
		hasDirectViewRestrictions,
		hasInheritedViewRestrictions,
	});
}
